module.exports = " <div class=breadcrumb> <a class=breadcrumb-item v-for=\"element in elements\" v-link=\"{ path: element.link }\" :class=\"{ active: element.active }\">{{ element.name }}</a> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/nav/Breadcrumb.vue
// module id = 512
// module chunks = 1